var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.908 7.487a.15.15 0 0 0-.166 0l-8.125 7.922a2.3 2.3 0 0 1-.742.483 2.356 2.356 0 0 1-2.5-.483l-8.117-7.89a.15.15 0 0 0-.166 0A.15.15 0 0 0 2 7.625v9.75c0 .431.176.844.488 1.149.313.305.737.476 1.179.476h16.666c.442 0 .866-.171 1.179-.476.312-.305.488-.718.488-1.149v-9.75a.14.14 0 0 0-.024-.083.15.15 0 0 0-.068-.055"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.258 14.58c.198.187.462.292.738.292s.54-.105.737-.292l8.075-7.873a.4.4 0 0 0 .1-.414C20.817 6 20.558 6 20.333 6H3.667c-.234 0-.484 0-.575.293a.4.4 0 0 0 .1.414z"
  })));
};
export default SvgEmail;